import { render, staticRenderFns } from "./veracidade-fornecedor.vue?vue&type=template&id=162f653e"
import script from "./veracidade-fornecedor.vue?vue&type=script&lang=js"
export * from "./veracidade-fornecedor.vue?vue&type=script&lang=js"
import style0 from "./veracidade-fornecedor.vue?vue&type=style&index=0&id=162f653e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports